import IntlGetNumberOptions from '../models/utils/IntlGetNumberOptions';
import IntlGetDateOptions from '../models/utils/IntlGetDateOptions';
import cultureSearchTransformReplace from './cultureSearchTransformReplace';
import { DataStore } from '../stores';

export class IntlInstanceCache {
    dateTimeCache = {};
    numberCache = {};

    getAppliedLocale = (locale: string, dataStore: DataStore) => {
        let appliedLocale = locale;
        if (
            dataStore &&
            dataStore.config &&
            dataStore.config.cultureSearchTransform
        ) {
            appliedLocale = cultureSearchTransformReplace(
                dataStore.config.cultureSearchTransform,
                locale
            );
        }
        return appliedLocale;
    };

    getDateTime = (getDateOptions: IntlGetDateOptions) => {
        const { locale, options, dataStore } = getDateOptions;
        const key = JSON.stringify([locale, options]);
        let intlInstance = this.dateTimeCache[key];
        if (!intlInstance) {
            const appliedLocale = this.getAppliedLocale(locale, dataStore);
            intlInstance = new Intl.DateTimeFormat(appliedLocale, options);
            this.dateTimeCache[key] = intlInstance;
        }
        return intlInstance;
    };

    getNumber = (getNumberOptions: IntlGetNumberOptions) => {
        const { locale, dataStore, options = {} } = getNumberOptions;
        const key = JSON.stringify([locale, options]);
        let intlInstance = this.numberCache[key];

        if (!intlInstance) {
            const appliedLocale = this.getAppliedLocale(locale, dataStore);
            intlInstance = new Intl.NumberFormat(appliedLocale, options);
            this.numberCache[key] = intlInstance;
        }

        return intlInstance;
    };
}

export default new IntlInstanceCache();



// WEBPACK FOOTER //
// ./src/utils/intlInstanceCache.ts